module.exports = __webpack_public_path__ + "static/media/return.0eff48b4.png";